import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { ClampToEdgeWrapping, LinearFilter, LinearMipmapLinearFilter, LinearMipmapNearestFilter, MirroredRepeatWrapping, NearestFilter, NearestMipmapLinearFilter, NearestMipmapNearestFilter, RepeatWrapping, Vector2 } from 'three';
import { toVector2D } from '../../model-viewer-base.js';
import { Filter, Wrap } from '../../three-components/gltf-instance/gltf-2.0.js';
import { $correlatedObjects, $onUpdate, ThreeDOMElement } from './three-dom-element.js';
// Convertion between gltf standards and threejs standards.
var wrapModeToWrapping = new Map([[Wrap.Repeat, RepeatWrapping], [Wrap.ClampToEdge, ClampToEdgeWrapping], [Wrap.MirroredRepeat, MirroredRepeatWrapping]]);
var wrappingToWrapMode = new Map([[RepeatWrapping, Wrap.Repeat], [ClampToEdgeWrapping, Wrap.ClampToEdge], [MirroredRepeatWrapping, Wrap.MirroredRepeat]]);
var minFilterToMinification = new Map([[Filter.Nearest, NearestFilter], [Filter.Linear, LinearFilter], [Filter.NearestMipmapNearest, NearestMipmapNearestFilter], [Filter.LinearMipmapNearest, LinearMipmapNearestFilter], [Filter.NearestMipmapLinear, NearestMipmapLinearFilter], [Filter.LinearMipmapLinear, LinearMipmapLinearFilter]]);
var minificationToMinFilter = new Map([[NearestFilter, Filter.Nearest], [LinearFilter, Filter.Linear], [NearestMipmapNearestFilter, Filter.NearestMipmapNearest], [LinearMipmapNearestFilter, Filter.LinearMipmapNearest], [NearestMipmapLinearFilter, Filter.NearestMipmapLinear], [LinearMipmapLinearFilter, Filter.LinearMipmapLinear]]);
var magFilterToMagnification = new Map([[Filter.Nearest, NearestFilter], [Filter.Linear, LinearFilter]]);
var magnificationToMagFilter = new Map([[NearestFilter, Filter.Nearest], [LinearFilter, Filter.Linear]]);
// Checks for threejs standards.
var isMinFilter = function () {
  return function (value) {
    return minificationToMinFilter.has(value);
  };
}();
var isMagFilter = function () {
  return function (value) {
    return magnificationToMagFilter.has(value);
  };
}();
var isWrapping = function () {
  return function (value) {
    return wrappingToWrapMode.has(value);
  };
}();
var isValidSamplerValue = function isValidSamplerValue(property, value) {
  switch (property) {
    case 'minFilter':
      return isMinFilter(value);
    case 'magFilter':
      return isMagFilter(value);
    case 'wrapS':
    case 'wrapT':
      return isWrapping(value);
    case 'rotation':
    case 'repeat':
    case 'offset':
      return true;
    default:
      throw new Error("Cannot configure property \"".concat(property, "\" on Sampler"));
  }
};
var $threeTexture = Symbol('threeTexture');
var $threeTextures = Symbol('threeTextures');
var $setProperty = Symbol('setProperty');
/**
 * Sampler facade implementation for Three.js textures
 */
export var Sampler = /*#__PURE__*/function (_ThreeDOMElement) {
  _inherits(Sampler, _ThreeDOMElement);
  var _super = _createSuper(Sampler);
  function Sampler(onUpdate, texture) {
    _classCallCheck(this, Sampler);
    return _super.call(this, onUpdate, new Set(texture ? [texture] : []));
  }
  _createClass(Sampler, [{
    key: $threeTexture,
    get: function get() {
      var _a;
      return (_a = this[$correlatedObjects]) === null || _a === void 0 ? void 0 : _a.values().next().value;
    }
  }, {
    key: $threeTextures,
    get: function get() {
      return this[$correlatedObjects];
    }
  }, {
    key: "name",
    get: function get() {
      return this[$threeTexture].name || '';
    }
  }, {
    key: "minFilter",
    get: function get() {
      return minificationToMinFilter.get(this[$threeTexture].minFilter);
    }
  }, {
    key: "magFilter",
    get: function get() {
      return magnificationToMagFilter.get(this[$threeTexture].magFilter);
    }
  }, {
    key: "wrapS",
    get: function get() {
      return wrappingToWrapMode.get(this[$threeTexture].wrapS);
    }
  }, {
    key: "wrapT",
    get: function get() {
      return wrappingToWrapMode.get(this[$threeTexture].wrapT);
    }
  }, {
    key: "rotation",
    get: function get() {
      return this[$threeTexture].rotation;
    }
  }, {
    key: "scale",
    get: function get() {
      return toVector2D(this[$threeTexture].repeat);
    }
  }, {
    key: "offset",
    get: function get() {
      return toVector2D(this[$threeTexture].offset);
    }
  }, {
    key: "setMinFilter",
    value: function setMinFilter(filter) {
      this[$setProperty]('minFilter', minFilterToMinification.get(filter));
    }
  }, {
    key: "setMagFilter",
    value: function setMagFilter(filter) {
      this[$setProperty]('magFilter', magFilterToMagnification.get(filter));
    }
  }, {
    key: "setWrapS",
    value: function setWrapS(mode) {
      this[$setProperty]('wrapS', wrapModeToWrapping.get(mode));
    }
  }, {
    key: "setWrapT",
    value: function setWrapT(mode) {
      this[$setProperty]('wrapT', wrapModeToWrapping.get(mode));
    }
  }, {
    key: "setRotation",
    value: function setRotation(rotation) {
      if (rotation == null) {
        // Reset rotation.
        rotation = 0;
      }
      this[$setProperty]('rotation', rotation);
    }
  }, {
    key: "setScale",
    value: function setScale(scale) {
      if (scale == null) {
        // Reset scale.
        scale = {
          u: 1,
          v: 1
        };
      }
      this[$setProperty]('repeat', new Vector2(scale.u, scale.v));
    }
  }, {
    key: "setOffset",
    value: function setOffset(offset) {
      if (offset == null) {
        // Reset offset.
        offset = {
          u: 0,
          v: 0
        };
      }
      this[$setProperty]('offset', new Vector2(offset.u, offset.v));
    }
  }, {
    key: $setProperty,
    value: function value(property, _value) {
      if (isValidSamplerValue(property, _value)) {
        var _iterator = _createForOfIteratorHelper(this[$threeTextures]),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var texture = _step.value;
            texture[property] = _value;
            texture.needsUpdate = true;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      this[$onUpdate]();
    }
  }]);
  return Sampler;
}(ThreeDOMElement);